<template>
  <HeaderSUUQ v-if="display.mobile.value" />
  <Header v-else />
  
   <v-container v-if="loading" fluid style="max-width: 1120px">
    <v-row>
      <v-col cols="12" md="8">
        <v-skeleton-loader type="article" class="mb-4" />
        <v-skeleton-loader type="image" class="mb-4" height="200" />
        <v-skeleton-loader
          type="paragraph"
          class="mb-4"
          :loading="true"
          :lines="12"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-skeleton-loader type="card" class="mb-4" height="300" />
      </v-col>
    </v-row>
   </v-container>

  <v-container v-else fluid class="jobs-homepage py-10" style="max-width: 1120px">
    <!-- Header Section -->
    <v-card class="header-block px-10 py-7 mb-7" flat>
      <div class="d-flex align-center justify-space-between flex-wrap">
        <div>
          <div class="headline font-weight-bold mb-2">
            Job hunting
            <span class="made-easy">made easy</span>
            <br />
            with Suuq
          </div>
          <v-text-field
            v-model="search"
            placeholder="Search for jobs"
            hide-details
            variant="outlined"
            class="mt-5 search-input"
            append-inner-icon="mdi-magnify"
            density="comfortable"
            style="max-width: 370px"
          />
        </div>
        <v-btn
          small
          class="text--primary recruiter"
          style="
            border: 1px solid #1976d2;
            border-radius: 4px;
            font-size: 12px;
            text-transform: none;
            color: blue;
          "
          variant="outlined"
        >
          I am a Recruiter
        </v-btn>
      </div>
    </v-card>

    <!-- Popular Jobs -->
    <!-- Popular Jobs (wired up) -->
    <div class="section-title mb-2">Popular Jobs</div>
    <v-row class="mb-7" dense>
      <v-col
        v-for="(job, i) in popularJobs"
        :key="i"
        cols="12"
        sm="6"
        md="3"
        class="d-flex"
      >
        <v-card class="card-shadow popular-job-card flex-grow-1" rounded="xl" @click="navigateToDetails(job)">
          <v-card-text class="py-6 px-5">
            <v-avatar size="38" class="mb-2" color="grey-lighten-3">
              <v-icon size="28" color="grey">mdi-briefcase</v-icon>
            </v-avatar>
            <div
              class="company font-weight-bold mb-1 text-grey-darken-2"
              style="font-size: 13px"
            >
              {{
                `${
                  job.isHideCompany === "Yes"
                    ? "Confidential"
                    : job.company_name
                }`
              }}
            </div>
            <div
              class="job-title font-weight-bold mb-1"
              style="font-size: 15px"
            >
              {{ job.title }}
            </div>
            <div class="d-flex align-center flex-wrap mb-1" style="gap: 8px">
              <span
                class="job-detail text-caption d-flex align-center"
                style="font-size: 12px"
              >
                <v-icon size="14" class="me-1" color="grey-lighten-1"
                  >mdi-clock-outline</v-icon
                >
                {{ job.commitment || "N/A" }}
              </span>
              <span
                class="job-detail text-caption d-flex align-center"
                style="font-size: 12px"
              >
                <v-icon size="14" class="me-1" color="grey-lighten-1"
                  >mdi-cash</v-icon
                >
                {{ job.salary_expectations || "N/A" }}
              </span>
            </div>
            <div
              class="d-flex align-center text-caption"
              style="font-size: 12px"
            >
              <v-icon size="14" class="me-1" color="grey-lighten-1"
                >mdi-map-marker</v-icon
              >
              {{ job.city?.title || "Somalia" }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Jobs by Category -->
    <div class="section-title mb-2">Jobs By Category</div>
<v-row class="mb-3" dense>
  <v-col
    v-for="cat in topCategories"
    :key="cat.slug"
    cols="12"
    sm="6"
    md="3"
    class="d-flex"
  >
    <v-card class="card-shadow job-category-card flex-grow-1" rounded="xl">
      <v-img :src="cat.img" height="100" cover class="rounded-t-xl" />
      <v-card-text class="py-2 px-4">
        <div class="font-weight-bold text-body-2 mb-1" style="font-size: 15px">
          {{ cat.name }}
        </div>
        <div class="text-caption grey--text" style="font-size: 13px">
          {{ cat.count }} Jobs
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>

<div class="text-center mb-7">
  <a href="javascript:void(0)" class="view-more-less" @click="toggleCategories" style="color: #1976d2; font-weight: 600; font-size: 16px; text-decoration: none !important">
    {{ showCategoryPills ? "View Less Categories" : "View More Categories" }}
    <v-icon right size="18">
      {{ showCategoryPills ? "mdi-chevron-up" : "mdi-chevron-right" }}
    </v-icon>
  </a>
</div>

<!-- Pills Section (only visible when showCategoryPills is true) -->
<div v-if="showCategoryPills" class="category-pills-container mb-2">
  <v-chip
    v-for="cat in allCategories"
    :key="cat.id"
    class="category-pill"
    color="grey-lighten-1"
    size="large"
    style="margin: 5px; font-size: 15px;"
  >
   <span style="color: black !important">{{ cat.title }}</span>  ({{ cat.count }}+ Jobs)
  </v-chip>
</div>


    <!-- Jobs by Qualification -->
    <!-- Jobs by Qualification in Somalia (wired up) -->
    <div class="section-title mb-2">Jobs By Qualification in Somalia</div>
    <v-row class="mb-7" dense>
      <v-col
        v-for="(qual, i) in jobsByQualification"
        :key="i"
        cols="12"
        sm="6"
        md="3"
        class="d-flex"
      >
        <v-card class="card-shadow qualification-card flex-grow-1" rounded="xl">
          <v-card-text class="py-6 px-5 text-center">
            <v-icon size="30" color="primary" class="mb-1">mdi-school</v-icon>
            <div class="font-weight-bold mb-1" style="font-size: 15px">
              {{ qual.education }}
            </div>
            <div class="text-caption grey--text" style="font-size: 13px">
              {{ qual.count }} Jobs
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  

    <div class="section-title mb-2">Jobs By Type in Somalia</div>
<v-row class="mb-7" dense>
  <v-col
    v-for="(type, i) in jobsByType"
    :key="i"
    cols="12"
    sm="6"
    md="3"
    class="d-flex"
  >
    <v-card class="card-shadow qualification-card flex-grow-1" rounded="xl">
      <v-card-text class="py-6 px-5 text-center">
        <v-icon size="30" color="primary" class="mb-1">
          <!-- Pick icon based on type (optional) -->
          <template v-if="type.type === 'Full Time'">mdi-briefcase</template>
          <template v-else-if="type.type === 'Part Time'">mdi-clock-outline</template>
          <template v-else-if="type.type === 'Remote'">mdi-laptop</template>
          <template v-else>mdi-briefcase-outline</template>
        </v-icon>
        <div class="font-weight-bold mb-1" style="font-size:15px">{{ type.type }}</div>
        <div class="text-caption grey--text" style="font-size:13px;">{{ type.count }} Jobs</div>
      </v-card-text>
    </v-card>
  </v-col>
</v-row>

    

    <!-- Featured Companies -->
    <div class="section-title mb-2">Featured Companies</div>
    <v-row class="mb-7" dense>
      <v-col
        v-for="(comp, i) in featuredCompanies"
        :key="i"
        cols="6"
        sm="4"
        md="2"
        class="d-flex"
      >
        <v-card
          class="card-shadow featured-company-card flex-grow-1 pa-3 d-flex flex-column align-center justify-center"
          rounded="xl"
        >
          <v-img
            :src="comp.logo"
            width="56"
            height="34"
            class="mb-2"
            style="object-fit: contain"
          />
          <div class="font-weight-bold text-caption" style="font-size: 13px">
            {{ comp.name }}
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- CV Upload Section -->
    <v-card
      class="card-shadow cv-section mt-8 px-6 py-6"
      flat
      rounded="xl"
      style="background: #f8fafc"
    >
      <v-row>
        <v-col cols="8">
          <div class="font-weight-bold mb-2" style="font-size: 18px">
            80% of the recruiters hire candidates with CV
          </div>
          <div class="mb-3 text-body-2">
            Here are some reasons why you should upload a CV to your profile:
          </div>
          <ul
            class="text-body-2 mb-3"
            style="padding-left: 24px; list-style-type: number"
          >
            <li>Boost your chances of getting ahead of other candidates</li>
            <li>Enable recruiters to easily view your contact details</li>
            <li>Showcase your personalized accomplishments</li>
          </ul>
          <v-btn
            
            class="font-weight-bold upload-cv"
            style="min-width: 140px; text-transform: none"
            @click="handleCvUpload"
          >
            {{ isResumeComplete ? "Update CV" : "Upload CV" }}

          </v-btn>
        </v-col>

        <v-col cols="4">
          <v-img
            src="@/assets/upload-cv.svg"
            height="200"
            class="rounded-xl"
            style="object-fit: cover"
          />
        </v-col>
      </v-row>
      <ResumeModal v-model="showResumeModal" />
    </v-card>
  </v-container>
  <!-- <FooterComponent /> -->
   <FooterMobile v-if="display.mobile.value" />
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Header from "@/components/Header.vue";
import FooterComponent from "@/components/footer/FooterComponent.vue";
import FooterMobile from "../footer/FooterMobile.vue";
import ResumeModal from "@/components/Jobs/Profile/Candidate/ResumeModal.vue";
import { API_URL } from "@/helpers/api";
import suuqLogo from "@/assets/suuq.logo.svg";
import { useDisplay } from "vuetify";
import HeaderSUUQ from "../HeaderSUUQ.vue";

const router = useRouter();
const store = useStore();
const display = useDisplay()

const showResumeModal = ref(false);

const loggedInUser = computed(() => store.state.auth.user);
const isAuthenticated = computed(() => !!loggedInUser.value);

const search = ref("");
const loading = ref(true);

const jobs = computed(() =>
  (store.getters["jobs/allJobListings"] || []).filter(
    job => job.listing?.status === 1
  )
);

const personalProfile = computed(() => store.getters["personalProfile/profile"]);
const companyProfile = computed(
  () => store.getters["companyProfile/companyProfile"]
);

const isResumeComplete = computed(() => {
  const p = store.state.profile;
  return Boolean(p.resumeBlob || p.resumeMeta);
});

// --- DYNAMIC JOB CATEGORIES SECTION (FIXED) --- //

const baseCategories = [
  {
    img: "https://images.pexels.com/photos/260689/pexels-photo-260689.jpeg",
    name: "Sales / Business Development",
    slug: "sales-business-development",
  },
  {
    img: "https://images.pexels.com/photos/210990/pexels-photo-210990.jpeg",
    name: "Accounting / Finance",
    slug: "accounting-finance",
  },
  {
    img: "https://images.pexels.com/photos/1267320/pexels-photo-1267320.jpeg",
    name: "Driver / Delivery",
    slug: "driver-delivery",
  },
  {
    img: "https://images.pexels.com/photos/325924/pexels-photo-325924.jpeg",
    name: "Secretarial / Front Office",
    slug: "secretarial-front-office",
  },
];

// Precompute job counts by group for better performance
const jobCountsByGroup = computed(() => {
  const counts = {};
  jobs.value.forEach(job => {
    if (job.group && job.group.slug) {
      counts[job.group.slug] = (counts[job.group.slug] || 0) + 1;
    }
  });
  return counts;
});

// Get ALL unique groups from all jobs (for pills)
const getAllGroups = () => {
  const groupsMap = new Map();
  
  jobs.value.forEach(job => {
    if (job.sub_category && job.sub_category.groups) {
      job.sub_category.groups.forEach(group => {
        if (!groupsMap.has(group.slug)) {
          groupsMap.set(group.slug, {
            id: group.id,
            title: group.title,
            slug: group.slug,
            count: jobCountsByGroup.value[group.slug] || 0
          });
        }
      });
    }
  });
  
  return Array.from(groupsMap.values());
};

// Returns the count of jobs for a given group slug
const getJobCountByGroupSlug = (slug) => {
  return jobCountsByGroup.value[slug] || 0;
};

// Compute the four top categories with live counts - FIXED
const topCategories = computed(() => {
  return baseCategories.map(cat => {
    const count = getJobCountByGroupSlug(cat.slug);
    return {
      ...cat,
      count: count
    };
  });
});

// All groups as pills with live job counts - FIXED
const allCategories = computed(() => {
  return getAllGroups();
});

// Show/hide pills toggle
const showCategoryPills = ref(false);
function toggleCategories() {
  showCategoryPills.value = !showCategoryPills.value;
}

// --- ORIGINAL HOMEPAGE LOGIC CONTINUES --- //

// "Popular Jobs" logic (first four jobs)
const popularJobs = computed(() => {
  return jobs.value.slice(0, 4);
});

// Jobs By Qualification
const jobsByQualification = computed(() => {
  const map = {};
  jobs.value.forEach((job) => {
    const key = job.education_level || "Other";
    map[key] = (map[key] || 0) + 1;
  });
  return Object.entries(map).map(([education, count]) => ({
    education,
    count,
  }));
});

// Jobs By Type
const jobsByType = computed(() => {
  const map = {};
  jobs.value.forEach((job) => {
    const key = job.commitment || "Other";
    map[key] = (map[key] || 0) + 1;
  });
  return Object.entries(map).map(([type, count]) => ({
    type,
    count,
  }));
});

const featuredCompanies = computed(() => {
  const unique = new Map();
  for (const job of jobs.value) {
    let name, logo;

    if (job.company_hiring) {
      name = job.company_hiring.name;
      logo = job.company_hiring.logo_path
        ? `${API_URL}${job.company_hiring.logo_path}`
        : suuqLogo;
    } else {
      name = job.company_name || "Unknown Company";
      logo = suuqLogo;
    }

    if (!unique.has(name)) {
      unique.set(name, { name, logo });
    }
    if (unique.size >= 4) break;
  }
  return Array.from(unique.values());
});

// Slug utility for routes
const generateSlug = (title) => {
  if (!title) return "listing";
  return title
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-|-$/g, "");
};

const navigateToDetails = (item) => {
  console.log("Navigating to details for item:", item);
  store.dispatch("FilterStore/setSelectedListingItem", item);

  const slug = generateSlug(item.title);

  router.push({
    name: "ListingDetailsForJobs",
    params: {
      id: item.id,
      slug: slug,
      listingId: item.listing.id || null
    },
  });
};

onMounted(async () => {
  await store.dispatch("jobs/fetchAllJobs");
  loading.value = false;
  console.log("Fetched Jobs", jobs.value);
  console.log("Profile CV", isResumeComplete.value);
  console.log("Personal Profile", personalProfile.value);
  console.log("Company Profile", companyProfile.value);
});

const handleCvUpload = () => {
  if (!isAuthenticated.value) {
    // Redirect to auth page if not logged in
    router.push("/auth-list" );
    return;
  }
  
  // If authenticated, show the resume modal
  showResumeModal.value = true;
};
</script>

<style scoped>
.jobs-homepage {
  background: #fff;
}
.header-block {
  background: #f8fafc;
  border-radius: 20px;
  min-height: 220px;
  box-shadow: 0 2px 10px 0 rgba(60, 72, 88, 0.07);
}


.category-pills-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
}
.category-pill {
  background: #f8fafc;
  color: black;
  border-radius: 18px;
  margin: 4px 4px 4px 0;
  font-weight: 700;
  padding: 8px 16px;
  cursor: pointer;
  transition: box-shadow 0.12s;
}
.category-pill:hover {
  box-shadow: 0 3px 10px 0 rgba(60, 72, 88, 0.13);
    outline: 1px solid #1976d2;
}


.view-more-less:hover {
 text-decoration: underline !important;
}

.headline {
  font-size: 2.25rem;
  line-height: 1.18;
  color: #222;
}
.made-easy {
  color: #B8860B;
  font-weight: bold;
}
.section-title {
  font-size: 1.18rem;
  font-weight: 700;
  margin: 30px 0 10px 0;
  color: #202124;
}

.card-shadow {
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(60, 72, 88, 0.07);
  border-radius: 18px;
}
.popular-job-card,
.job-category-card,
.qualification-card,
.featured-company-card,
.cv-section {
  transition: box-shadow 0.16s;
  min-height: 100px;
}
.popular-job-card:hover,
.job-category-card:hover,
.qualification-card:hover,
.featured-company-card:hover {
  box-shadow: 0 6px 20px 0 rgba(60, 72, 88, 0.14);
}
.v-btn.text--primary {
  border: 1px solid #1976d2 !important;
  background: #e3f0fb !important;
  color: #1976d2 !important;
  font-weight: 600;
  border-radius: 8px !important;
}

.cv-section {
  background: #f8fafc !important;
  border-radius: 18px;
}
.search-input .v-input__control {
  border-radius: 12px !important;
  font-size: 15px;
}
ul {
  margin-bottom: 0;
}


.upload-cv {
  color: #B8860B;
  background-color: none;
  outline: solid 1px #B8860B;
}

@media (max-width: 900px) {
  .header-block {
    min-height: 180px;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}

@media (max-width: 950px) {
  .recruiter {
    margin-top: 40px;
  }
}
</style>
